import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { authAPI } from '../../utils/adminAPI';
import { possivelSessaoAdmin } from '../../utils/sessaoHint';

// Envolve TODA rota pública de enquete (dinâmica ou legada). Restrição
// absoluta: quem está logado (admin ou gerenciador) NUNCA pode ficar numa
// rota pública, só sai do gerenciador via logout explícito ou sessão
// expirada — nunca navegando pra fora. Antes disso a defesa só reagia
// depois que a própria página tentava chamar a API pública e tomava 403
// (ADMIN_SESSION_ACTIVE) do backend, o que deixava a rota pública "alcançável"
// por um instante. Este guard checa a sessão em paralelo, sem atrasar o
// carregamento pro visitante comum (não bloqueia o render), e assim que
// descobre que existe sessão válida, redireciona na hora pra /admin —
// substituindo qualquer conteúdo que a página tenha chegado a mostrar.
// O bloqueio de verdade, que nenhum client pode burlar, continua sendo o
// 403 do backend (blockIfAdmin) — isto aqui é reforço de UX no frontend.
const PublicRouteGuard = ({ children }) => {
  const [logado, setLogado] = useState(false);

  useEffect(() => {
    // Sem o cookie de aceno, não existe sessão — nem vale perguntar ao
    // backend (evita a requisição e o 401 esperado dela pra esmagadora
    // maioria dos visitantes, que nunca logaram nesse navegador).
    if (!possivelSessaoAdmin()) return;

    let ativo = true;
    authAPI.me()
      .then(() => { if (ativo) setLogado(true); })
      .catch(() => { /* aceno existia mas a sessão não é mais válida — trata como visitante anônimo */ });
    return () => { ativo = false; };
  }, []);

  if (logado) {
    return <Navigate to="/admin" replace />;
  }

  return children;
};

export default PublicRouteGuard;
